<div class="modal-header bg-danger text-light" [draggable] [drag-container]="'.modal-content'">
    <h6 class="modal-title">{{options?.title}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="discard()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="min-height:100px">
    <p>
        {{options?.body}}
    </p>
</div>
<div class="modal-footer border-0">
    <button type="button" class="btn btn-default" (click)="commit()">Confirm</button>
    <button type="button" class="btn btn-danger" (click)="discard()">Cancel</button>
</div>